"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../../config/constants"));
var actions_1 = require("../../../redux/reducers/app/actions");
var actions_2 = require("../../../redux/reducers/authentication/actions");
var actions_3 = require("../../../redux/reducers/password/actions");
var PasswordStrengthIndicator_1 = __importDefault(require("../../../shared/components/password/PasswordStrengthIndicator"));
var styles_1 = __importDefault(require("./styles"));
var validations_1 = require("./validations");
var ChangePasswordScreen = function (_a) {
    var changeSection = _a.changeSection;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.passwordChange; }), success = _b.success, checking = _b.checking, currentPasswordValid = _b.currentPasswordValid;
    var _c = react_1.default.useState(''), currentPassword = _c[0], setCurrentPassword = _c[1];
    var _d = react_1.default.useState(''), newPassword = _d[0], setNewPassword = _d[1];
    var _e = react_1.default.useState(''), confirmPassword = _e[0], setConfirmPassword = _e[1];
    var labelProps = {
        useAlternateTextField: true,
        isRequiredLabel: true,
        labelStyle: __assign(__assign({}, theme.typography.body2), { padding: theme.spacing(0, 2), gap: '2px' })
    };
    react_1.default.useEffect(function () {
        if (success) {
            dispatch((0, actions_2.logout)());
        }
    }, [success]);
    react_1.default.useEffect(function () {
        return function () {
            dispatch((0, actions_3.resetChangePassword)());
        };
    }, []);
    var passwordErrors = validations_1.passwordValidatorSchema.validate(newPassword, {
        list: true
    });
    var confirmPasswordErrors = validations_1.passwordValidatorSchema.validate(confirmPassword, {
        list: true
    });
    var activeButton = (passwordErrors === null || passwordErrors === void 0 ? void 0 : passwordErrors.length) === 0 &&
        (confirmPasswordErrors === null || confirmPasswordErrors === void 0 ? void 0 : confirmPasswordErrors.length) === 0 &&
        currentPasswordValid &&
        confirmPassword === newPassword;
    var currentPasswordField = {
        type: 'password',
        key: 'currentPassword',
        label: 'Current Password',
        get placeholder() {
            return this.label;
        },
        value: currentPassword,
        disabled: checking,
        isRequired: true,
        showPassword: true,
        secureTextEntry: true,
        get fieldValue() {
            return this.value;
        },
        validationSchema: validations_1.currentPasswordValidation
    };
    var newPasswordField = {
        type: 'password',
        key: 'newPassword',
        label: 'New Password',
        get placeholder() {
            return this.label;
        },
        value: newPassword,
        isRequired: true,
        showPassword: true,
        secureTextEntry: true,
        get fieldValue() {
            return this.value;
        },
        validationSchema: validations_1.passwordValidation
    };
    var confirmPasswordField = {
        type: 'password',
        key: 'confirmPassword',
        label: 'Confirm Password',
        get placeholder() {
            return this.label;
        },
        value: confirmPassword,
        disabled: checking,
        isRequired: true,
        showPassword: true,
        secureTextEntry: true,
        get fieldValue() {
            return this.value;
        },
        validationSchema: validations_1.passwordValidation
    };
    var onChangePassword = function () {
        if (currentPassword === newPassword) {
            dispatch((0, actions_1.showMessageBar)({
                type: 'error',
                message: 'password.samePassword'
            }));
            return;
        }
        dispatch((0, actions_3.changePassword)(currentPassword || '', newPassword || ''));
    };
    var onCheckPassword = function () {
        if (currentPassword) {
            dispatch((0, actions_3.checkPassword)(currentPassword));
        }
    };
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, direction: "column" },
        react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(package_1.FieldRenderer, { field: currentPasswordField, onChange: setCurrentPassword, labelProps: labelProps, className: classes.field, inputProps: {
                    autoComplete: "current-password",
                    error: currentPasswordValid !== null && !currentPasswordValid,
                    helperText: currentPasswordValid !== null && !currentPasswordValid ? 'Invalid Password' : null,
                    fullWidth: true,
                    onBlur: onCheckPassword,
                    variant: constants_1.default.FIELDS_VARIANT
                } })),
        react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(package_1.FieldRenderer, { field: newPasswordField, onChange: setNewPassword, labelProps: labelProps, className: classes.field, inputProps: {
                    autoComplete: "new-password",
                    fullWidth: true,
                    variant: constants_1.default.FIELDS_VARIANT
                } })),
        react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(package_1.FieldRenderer, { field: confirmPasswordField, onChange: setConfirmPassword, labelProps: labelProps, className: classes.field, inputProps: {
                    autoComplete: "new-password",
                    error: confirmPassword !== newPassword,
                    helperText: 'New Password and Confirm password are not the same',
                    fullWidth: true,
                    variant: constants_1.default.FIELDS_VARIANT
                } })),
        react_1.default.createElement(PasswordStrengthIndicator_1.default, { password: newPassword, passwordErrors: passwordErrors }),
        react_1.default.createElement(core_1.Grid, { item: true, style: { display: 'flex', justifyContent: 'center' } },
            react_1.default.createElement(core_1.Button, { size: "large", variant: "contained", color: "primary", "aria-label": "Change Password", onClick: onChangePassword, disabled: !activeButton }, "Change Password"))));
};
exports.default = ChangePasswordScreen;
//# sourceMappingURL=ChangePassword.js.map